module.exports = "/images/es-ml.svg?6d8d1f1884bc95dae7013bf85df5d1a3";